

export const equalFillPortfolio = (tickers) => {
    const numberOfTickers = tickers.length;
    const equalWeightValue = 1 / numberOfTickers;
    return tickers.map(ticker => ({
      ...ticker,
      wgt: equalWeightValue
    }));
}

export const proRataFillPortfolio = (tickers, maxPerHolding=0) => {
    console.log('maxPerHolding', maxPerHolding)
    let totalWeight = tickers.reduce((sum, ticker) => sum + parseFloat(ticker.wgt), 0);
    let scaleFactor = 1 / totalWeight;

    if (maxPerHolding === 0) {
        return tickers.map(ticker => ({
            ...ticker,
            wgt: parseFloat(ticker.wgt) * scaleFactor
        }));
    }
        tickers = tickers.map(ticker => ({
        ...ticker,
        wgt: parseFloat(ticker.wgt) * scaleFactor
    }));

    let excessWeight = 0;
    let adjustmentsNeeded;
    do {
        adjustmentsNeeded = false;
        excessWeight = 0;

        tickers = tickers.map(ticker => {
            if (ticker.wgt > maxPerHolding) {
                excessWeight += ticker.wgt - maxPerHolding;
                adjustmentsNeeded = true;
                return { ...ticker, wgt: maxPerHolding };
            }
            return ticker;
        });

        if (excessWeight > 0) {
            let adjustableTickers = tickers.filter(ticker => ticker.wgt < maxPerHolding);
            let adjustableTickersTotalWeight = adjustableTickers.reduce((sum, ticker) => sum + ticker.wgt, 0);

            if (adjustableTickersTotalWeight === 0) {
                break; // Break the loop if redistribution is not possible.
            }

            const additionalScaleFactor = excessWeight / adjustableTickersTotalWeight;

            tickers = tickers.map(ticker => {
                if (ticker.wgt < maxPerHolding) {
                    let additionalWeight = ticker.wgt * additionalScaleFactor;
                    if (ticker.wgt + additionalWeight > maxPerHolding) {
                        excessWeight += ticker.wgt + additionalWeight - maxPerHolding;
                        ticker.wgt = maxPerHolding;
                        adjustmentsNeeded = true;
                    } else {
                        ticker.wgt += additionalWeight;
                    }
                }
                return ticker;
            });
        }
    } while (adjustmentsNeeded && excessWeight > 0);

    return tickers;

}
